import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import * as actions from '../../../actions';

import { DeleteOutlined, SaveOutlined, CloudDownloadOutlined, DownloadOutlined } from '@ant-design/icons';
import { CSVLink } from 'react-csv';
import Button from 'components/forms/Button';
import Tooltip from 'components/Tooltip';
import SavesManagementModal from '../SavesManagementModal';
import SaveModal from '../SaveModal';

const StickyFooter = styled.div`
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0%);
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    height: 7.5em;
    width: 20em;

    border: 1px solid #eaeaea;
    border-radius: 2px;
    background-color: white;
    box-shadow: 0 2px 4px 0 rgba(215, 215, 215, 0.5);
`;

const FormActions = ({ formType, extractStateToSave, exportedCSVData, exportedFileName }) => {
    const dispatch = useDispatch();

    const [savesMngtModalVisible, setSavesMngtModalVisible] = useState(false);
    const [saveModalVisible, setSaveModalVisible] = useState(false);

    const onResetForm = () => {
        dispatch(actions.resetForm());
    };
    const onOpenSavesMngtModal = () => {
        setSavesMngtModalVisible(true);
    };
    const onCloseSavesMngtModal = () => {
        setSavesMngtModalVisible(false);
    };
    const onOpenSaveModal = () => {
        setSaveModalVisible(true);
    };
    const onCloseSaveModal = () => {
        setSaveModalVisible(false);
    };

    useEffect(
        () => () => {
            // When component un-mount, e.g. moving page
            // This is to reset everything, including which save is loaded
            onResetForm();
        },
        [],
    );

    return (
        <>
            <StickyFooter>
                <div>
                    <CSVLink data={exportedCSVData} filename={exportedFileName}>
                        <Tooltip title="Export to CSV">
                            <Button size="large" shape="circle" icon={<DownloadOutlined />} />
                        </Tooltip>
                    </CSVLink>
                </div>
                <div>
                    <Tooltip title="Clear all fields">
                        <Button size="large" shape="circle" icon={<DeleteOutlined />} onClick={onResetForm} />
                    </Tooltip>
                </div>
                <div>
                    <Tooltip title="Open previously saved work">
                        <Button
                            size="large"
                            shape="circle"
                            icon={<CloudDownloadOutlined />}
                            onClick={onOpenSavesMngtModal}
                        />
                    </Tooltip>
                </div>
                <div>
                    <Tooltip title="Save my work">
                        <Button size="large" shape="circle" icon={<SaveOutlined />} onClick={onOpenSaveModal} />
                    </Tooltip>
                </div>
            </StickyFooter>
            <SavesManagementModal visible={savesMngtModalVisible} formType={formType} onClose={onCloseSavesMngtModal} />
            <SaveModal
                extractStateToSave={extractStateToSave}
                visible={saveModalVisible}
                formType={formType}
                onClose={onCloseSaveModal}
            />
        </>
    );
};

export default FormActions;
